import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const LOOP = {
  duration: 4.5,
  ease: [0.23, 1, 0.32, 1] as const,
  repeat: Infinity,
  times: [0, 0.45, 0.64, 0.72, 0.8, 1]
};
export function GapTrack() {
  const reduce = useReducedMotion();
  return <div aria-hidden className="flex w-full max-w-[400px] items-start gap-4" data-id="element-248" data-mp="29vov4svoghto">
      <div className="flex flex-col items-center gap-2" data-id="element-249" data-mp="29xrva5qjnrc4">
        <span className="mt-[3px] h-[9px] w-[9px] rounded-full bg-ink ring-4 ring-ink-soft" data-id="element-250" data-mp="1w390afcxjq3u" />
        <span className="text-[10.5px] font-semibold uppercase tracking-[0.08em] text-fg-faint" data-id="element-251" data-mp="20va73lrbwomh">Plan</span>
      </div>

      <div className="relative mt-[6px] h-0.5 flex-1" data-id="element-252" data-mp="1m7fcu0xoac7a">
        <div className="absolute inset-x-0 top-0 border-t-2 border-dashed border-line" data-id="element-253" data-mp="1r4xpo2et9bkk" />
        {reduce ? <div className="absolute inset-0 rounded-full bg-ink" data-id="element-254" data-mp="1d4wf1v8quprw" /> : <>
            <motion.div className="absolute inset-y-0 left-0 rounded-full bg-ink" animate={{
          width: ['0%', '100%', '100%', '100%', '0%', '0%'],
          opacity: [1, 1, 1, 0, 0, 1]
        }} transition={LOOP} data-id="element-255" data-mp="1i50vxmdkdmin" />
            <motion.span className="absolute top-1/2 h-[11px] w-[11px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-coral ring-[5px] ring-coral-soft" animate={{
          left: ['0%', '100%', '100%', '100%', '0%', '0%'],
          opacity: [1, 1, 1, 0, 0, 1]
        }} transition={LOOP} data-id="element-256" data-mp="1ysm8t4q5j5mj" />
          </>}
      </div>

      <div className="flex flex-col items-center gap-2" data-id="element-257" data-mp="1f5esh1dg7q5t">
        <span className="mt-[3px] h-[9px] w-[9px] rounded-full bg-coral ring-4 ring-coral-soft" data-id="element-258" data-mp="1f2tpua5bt670" />
        <span className="text-[10.5px] font-semibold uppercase tracking-[0.08em] text-fg-faint" data-id="element-259" data-mp="1tvvsqhecka14">Do</span>
      </div>
    </div>;
}